<template>
    <div id="user-info-phone">
        <a-form class="form" :form="form" @submit="handleSubmit">
            <a-form-item label="新手机号码：" :label-col="{ span: 5}" :wrapper-col="{ span: 12 }">
                <a-input
                    placeholder="请输入新的手机号"
                    v-decorator="['phone',{ rules: [
                        { required: true, message: '请输入你的新手机号码！' },
                        { pattern: new RegExp('^[1][3,4,5,7,8][0-9]{9}$','g'),message:'必须是11位有效的手机号码！'},
                        ]}]"
                    help="必须是11位有效的手机号码！"
                >
                </a-input>
            </a-form-item>
            <a-form-item label="验证码" :label-col="{ span: 5}" :wrapper-col="{ span: 12 }">
                <a-input
                    placeholder="请收入你的短信验证码"
                    v-decorator="['code',{ rules: [
                        { required: true, message: '请输入你的验证码！' },
                        { pattern: new RegExp('^[0-9]{6}$','g'),message:'验证码为6位数字！'},
                        ]}]"
                    help="验证码为6位数字！"
                >
                    
                </a-input>
            </a-form-item>
            <a-form-item
                :wrapper-col="{ span: 12, offset: 5 }"
            >
                <a-button
                    type="primary"
                    html-type="submit"
                >
                    完成
                </a-button>
                <a-button 
                    :disabled="disabled" 
                    type="primary" 
                    style="margin-left:30px;" 
                    @click="getCode"
                >
                    {{disabled ? num+' 秒': '获取验证码'}}
                </a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
import Cookies from 'js-cookie';
import Mixins from "@/utils/Mixins.js";
export default {
    name:"UserInfoPhone",
    mixins:[Mixins],
    data () {
        return {
            form: this.$form.createForm(this),
            disabled: false,
            num: 60,
            saveSetInter:null
        };
    },
    mounted(){
        this.initPhoneCodeTime()
    },
    methods: {
        handleSubmit(e){
           e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.showConfirm(values);
                }
            });
        },
        showConfirm(values) {
            let _this = this;
            // this.$confirm({
            //     title: '重要操作，谨慎选择！',
            //     content: '确定要更换绑定的手机号码吗？',
            //     onOk() {
            //         _this.changePhone(values)
            //     },
            //     onCancel() {
            //
            //     }
            // });

            this.$confirm('确定要更换绑定的手机号码吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.changePhone(values)
            }).catch(() => {

            });
        },
        // 更换手机号码
        changePhone(values){
            let url = UrlApi.bindPhone;
            let userId = this.$store.getters.getUserId;
            let token = this.$store.getters.getToken;
            let param = `phone=${values.phone}&checkCode=${values.code}&userId=${userId}`;
            this.$http.post(url,param,{
                headers:{
                   "Authorization":token
               }
           }).then((res)=>{
                if(res.data.success){
                    this.$message.success(res.data.message);
                    setTimeout(()=>{
                        Cookies.remove("BSG-savePassword");
                        Cookies.remove("BSG-userInfo");
                        Cookies.remove("BSG-phoneCodeTime");
                        let userInfo = {
                            userId: null,
                            token: null,
                            userName: null
                        }
                        this.upDateUserInfo(userInfo);
                        let url = window.location.href.slice(0,window.location.href.indexOf("personal?edit=phone"));
                        window.open(url,"_self");
                    },2000)
                }else {
                    this.$message.warning(res.data.message);
                }
            })
        },
        // 获取验证码操作
        getCode(){
            this.form.validateFields(['phone'], (errors, values) => {
                if(!errors){
                    Cookies.set("BSG-phoneCodeTime",{
                        phone: values.phone,
                        time: Date.parse(new Date())
                    });
                    this.disableGetCode();
                    this.getPhoneCode(values.phone);
                }
            });
        },
        // 初始化手机获取验证码
        initPhoneCodeTime(){
            let info = Cookies.get("BSG-phoneCodeTime");
            if(info){
                info = JSON.parse(info);
                let now = Date.parse(new Date());
                if((now - info.time) >= 60000){
                    Cookies.remove("BSG-phoneCodeTime");
                    this.disabled = false;
                }else {
                    this.form.setFieldsValue(
                        {
                            phone: info.phone
                        }
                    );
                    this.num = this.num - (now - info.time)/1000;
                    this.disableGetCode();
                }
            }
        },
        // 获取手机验证码
        getPhoneCode(phone){
            let url = UrlApi.getPhoneCode;
            let param = `phone=${phone}&type=0`;
            this.$http.post(url,param).then((res)=>{
                if(res.data.success){
                    this.$message.success(res.data.message);
                }else {
                    this.$message.warning(res.data.message);
                    clearInterval(this.saveSetInter);
                    this.disabled = false;
                    Cookies.remove("BSG-phoneCodeTime");
                }
            })
        },
        // 禁用获取验证码按钮 并显示时间
        disableGetCode(){
            this.disabled = true;
            this.saveSetInter = setInterval(()=>{
                this.num = this.num - 1;
                if(this.num === 0){
                    clearInterval(this.saveSetInter);
                    this.disabled = false;
                }
            },1000);
        }
    }
}

</script>
<style lang="less" scoped>
    #user-info-phone {

    }
</style>